export const {
  VITE_SUPABASE_URL: SUPABASE_URL,
  VITE_SUPABSE_PUBLIC_KEY: SUPABASE_PUBLIC_KEY,
  VITE_SUPABASE_REDIRECT_URL: SUPABASE_REDIRECT_URL,
  VITE_MIXPANEL_TOKEN: MIXPANEL_TOKEN,
  VITE_STRIPE_PUBLISHABLE_KEY: STRIPE_PUBLISHABLE_KEY,
} = import.meta.env;
